import { Icon } from "@nju/icons";
import { Text } from "@nju/ui";
import {
  hasAtLeastOneDigit,
  hasLowerAndUpperCase,
  hasSpecialChar,
} from "@nju/utils";

interface IPasswordValidationProps {
  value: string;
}

const passwordChecks = [
  {
    text: "minimum 8 znaków",
    check: (value: string) => {
      return value.length > 7;
    },
  },
  {
    text: "małe i wielkie litery",
    check: hasLowerAndUpperCase,
  },
  {
    text: "przynajmniej jedna cyfra",
    check: hasAtLeastOneDigit,
  },
  {
    text: "min. jeden znak specjalny (@#-_$%^&+=§!?)",
    check: hasSpecialChar,
  },
];

export function PasswordValidation({ value }: IPasswordValidationProps) {
  return (
    <div>
      {passwordChecks.map(({ text, check }) => {
        const isValid = check(value);

        return (
          <div
            className="flex items-center mb-2"
            data-cy="password-validation-indicator"
            key={text}
          >
            <Icon
              className="mr-2"
              name="check"
              tone={isValid ? "accent" : "complementary"}
            />
            <Text size="m">{text}</Text>
          </div>
        );
      })}
    </div>
  );
}
